import { IMeetingFolder } from '../../../resource/meeting-folder/meeting-folder.types';
import * as constants from './meeting-folder.constants';
import * as types from './meeting-folder.types';
import { IMeetingFolderCreatePayload, IMeetingFolderUpdatePayload } from './meeting-folder.types';

export const fetchMeetingFolders = () => ({
  type: constants.FETCH_MEETING_FOLDER,
});

export const createMeetingFolder = (payload: IMeetingFolderCreatePayload): types.ICreateMeetingFolder => ({
  type: constants.CREATE_MEETING_FOLDER,
  payload,
});

export const updateMeetingFolder = (payload: IMeetingFolderUpdatePayload): types.IUpdateMeetingFolder => ({
  type: constants.UPDATE_MEETING_FOLDER,
  payload,
});

export const deleteMeetingFolder = (meetingFoldersId: IMeetingFolder['id']): types.IDeleteMeetingFolder => ({
  type: constants.DELETE_MEETING_FOLDER,
  payload: meetingFoldersId,
});

export const storeMeetingFoldersIds = (meetingFoldersIds: IMeetingFolder['id'][]): types.IStoreMeetingFolder => ({
  type: constants.STORE_MEETING_FOLDER_IDS,
  payload: meetingFoldersIds,
});
